import { IUtilityMapStatus } from 'types';

export type UtilityMapProcessName = keyof IUtilityMapStatus;

const isRunning = (status: IUtilityMapStatus | null, processName: UtilityMapProcessName): boolean =>
	status?.[processName].status === 'running';

export const isUtilityMapProcessRunning = (status: IUtilityMapStatus | null): boolean =>
	isRunning(status, 'byStreet') || isRunning(status, 'byCity') || isRunning(status, 'allRejects');

export const getUtilityMapProcessingMessage = (status: IUtilityMapStatus | null): string | null => {
	if (!isUtilityMapProcessRunning(status)) {
		return null;
	}

	return 'ВІДБУВАЄТЬСЯ ОБРОБКА АДРЕС. Дочекайтеся завершення перед запуском нової обробки (парсингу)';
};
